import React from "react";

import styles from "./CheckBox.module.scss";

const CheckBox = ({
  indeterminate: isIndeterminate,
  label,
  selected: isSelected,
  isDisabled = false,
  ...rest
}) => {
  const inputRef = React.useRef();
  const prevIndeterminate = React.useRef();
  React.useEffect(() => {
    if (inputRef.current && prevIndeterminate.current !== isIndeterminate) {
      prevIndeterminate.current = isIndeterminate;
      inputRef.current.indeterminate = isIndeterminate;
    }
  }, [isIndeterminate]);

  return (
    <label className={styles.base}>
      <input
        className={`${isDisabled ? styles.disabled : ""}`}
        ref={inputRef}
        type="checkbox"
        checked={isSelected}
        {...rest}
      />
      {label && <span>{label}</span>}
    </label>
  );
};

export default CheckBox;
